export default "__VITE_ASSET__ClkYdST5__"